__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/9283fe8/packs/";